<template>
  <With_Header_Modal_Template title="Новая запись">
    <div class="new_record">
      <div class="new_record_content">
        <custom-input placeholder="Название" mb="15px" v-model="form.title"/>
        <custom-input placeholder="Цена" mb="15px" v-model="form.price"/>
        <custom-select width="100%" mb="15px" maxWidth="100%" placeholder="Тип">
          <option>Визаж</option>
        </custom-select>
        <custom-select width="100%" mb="15px" maxWidth="100%" placeholder="Коворкинг">
          <option
            v-for="(c, idx) in coworking"
            :key="idx"
          >Beauty Coworking #1</option>
        </custom-select>
        <custom-input mb="15px" type="date" v-model="form.date"/>
        <div class="time_picker">
          <custom-input type="time" step="1800" v-model="form.start"/>
          <span class="line_between">—</span>
          <custom-input type="time" step="1800" v-model="form.end"/>
        </div>

        <transition name="fade">
          <div v-if="types">
            <custom-select mb="15px" max-width="100%" placeholder="Специализация" @change="form.type = $event;errors.specialization_id=null" :value="form.type">
              <option v-for="(type, i) in types" :value="type.id" :key="i+'type'"> {{ type.name }}</option>
            </custom-select>
            <error-text :text="errors.specialization_id"/>
          </div>
        </transition>

      </div>
      <div class="new_record_bottom">
        <ButtonComponent variant="filled" width="100%">Создать</ButtonComponent>
      </div>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import ButtonComponent from '@/components/ui/buttons/button-component'
import CustomInput from '@/components/ui/inputs/custom-input'
import CustomSelect from '@/components/ui/inputs/custom-select'
import ErrorText from '@/components/ui/text/error-text'
import { mapGetters } from 'vuex'

export default {
  name: "NewRecord",
  components: {ErrorText, CustomSelect, CustomInput, ButtonComponent, With_Header_Modal_Template},
  data: () => ({
    errors: {},
    clients: [],
    // coworking: null,
    coworking: [],
    form: {
      date: this.$moment().format("YYYY-MM-DD"),
      start: '00:00',
      end: '23:59',
      title: '',
      price: '',
      client: '',
      type: '',
      cowork: '',
    },
    fevent: null,
    edit: false,
    coords: {
      left: 0,
      right: 0
    },
  }),
  computed: {
    ...mapGetters(['modal_data']),
    clientName() {
      return this.form.client ? this.form.client.full_name : null;
    },
    emptyCoworking() {
      return this.coworking && !this.coworking.length;
    },
    loading() {
      return !this.coworking;
    },
    disabled() {
      return this.loading || !this.coworking.length;
    },
    types() {
      return this.coworking.filter(val => val.id === parseInt(this.form.cowork)).map(val => val.specializations)[0];
    },
  },
  methods: {
    loadClients(search) {
      this.form.client = null;
      this.$api.master.client.list({perPage: 50, search}).then(({data}) => this.clients = data);
    },
    loadCoworking(rent_from, rent_to) {
      this.$api.coworking.list({perPage: 100, rent_from, rent_to}).then(({data}) => {
        this.coworking = data;
        console.log(data)
        if (!this.coworking.length) return this.$toast.error('Не в одном из коворкингов нет забронированного места на данное время');
      });
      return this;
    },
    create() {
      this.$api.master.record.create(this.getSaveData()).then(({data}) => {
        this.$toast.success('Новая запись успешно создана!');
        this.$emit('create', data);
        this.close();
      }).catch(({response}) => {
        if (response.data.errors) this.errors = response.data.errors;
      });
    },
    update() {
      this.$api.master.record.update(this.form.id, this.getSaveData()).then(({data}) => {
        this.$toast.success('Сохранено!');
        this.$emit('edit', data);
        this.close();
      }).catch(({response}) => {
        if (response.data.errors) this.errors = response.data.errors;
      });
    },
    submit() {
      this.edit ? this.update() : this.create();
    },
    open() {
      this.clear();
      this.loadCoworking(
          this.$moment(`${this.form.start} ${this.form.date}`, 'HH:mm YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'),
          this.$moment(`${this.form.end} ${this.form.date}`, 'HH:mm YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'),
      );
    },
    setClient(client) {
      this.form.client = client;
      this.errors.client_id = null;
      this.clients = [];
    },
    setCreateData(e) {
      this.form.date = this.$moment(e.start).format('YYYY-MM-DD')
      this.form.edate = this.$moment(e.end).format('YYYY-MM-DD')
      this.form.start = this.$moment(e.start).format('HH:mm')
      this.form.end = this.$moment(e.end).format('HH:mm')
    },
    setEditData(e) {
      this.form.date = this.$moment(e.event.start).format('YYYY-MM-DD')
      this.form.edate = this.$moment(e.event.end).format('YYYY-MM-DD')
      this.form.start = this.$moment(e.event.start).format('HH:mm')
      this.form.end = this.$moment(e.event.end).format('HH:mm')
      this.form.title = e.event.extendedProps.name;
      this.form.id = e.event.id;
      this.form.price = e.event.extendedProps.sum;
      this.form.client = e.event.extendedProps.client;
      this.form.cowork = e.event.extendedProps.coworking_id;
      this.form.type = e.event.extendedProps.coworkingSpecialization.id;
    },
    getSaveData() {
      return {
        name: this.form.title,
        sum: this.form.price,
        client_id: this.form.client ? this.form.client.id : '',
        start: this.getDate(this.form.date, this.form.start),
        end: this.getDate(this.form.edate, this.form.end),
        coworking_id: this.form.cowork,
        specialization_id: this.form.type,
      };
    },
    getDate(date, time) {
      if (!date || !time) return '';
      return this.$moment(date, 'YYYY-MM-DD').set('hours', time.split(':')[0]).set('minutes', time.split(':')[1]).format('YYYY-MM-DD HH:mm:ss');
    },
    clear() {
      this.fevent = null;
      this.form = {
        date: this.$moment().format("YYYY-MM-DD"),
        start: '00:00',
        end: '23:59',
        title: '',
        price: '',
        client: '',
        type: '',
        cowork: '',
      }
      this.coworking = null;
      this.search = [];
      this.errors = {};
    },
    close() {
      this.show = false;
      this.clear();
    }
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        console.log('val', val)
        console.log('oldVal', oldVal)
      },
      deep: true
    }
  },
  mounted() {
    this.open(this.modal_data)
  }
}
</script>

<style scoped lang="scss">
.new_record {
  padding: 20px 15px;
  &_content {
    height: calc(100vh - 170px);
    margin-bottom: 20px;
    overflow: auto;
  }
}

.time_picker {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  .line_between {
    margin: 0 7px;
  }
}

</style>
